import PropTypes from "prop-types"
import React from "react"
import { useMarina } from "src/contexts/MarinaContext"

import { formatCurrencyFromMinorUnits } from "src/utils/UnitConversion"
import { calculateItemizedTaxTotal } from "src/utils/tax_calculation"

import { RECORD_WITHOUT_BILLING } from "./MeteredElectricConstants"

const MeteredElectricCostLabel = ({
  lastReading,
  product,
  meterReading,
  billingOption,
  useNewTaxExperience,
}) => {
  const { presentmentCurrency, currencySymbol } = useMarina()
  let costString
  const recordWithoutBilling = billingOption === RECORD_WITHOUT_BILLING.value
  if (lastReading === null) {
    costString = "Initial Reading"
  } else if (meterReading === null || meterReading === "") {
    if (recordWithoutBilling) {
      costString = "0 kWh net usage"
    } else {
      costString = `${currencySymbol}0.00 for 0 kWh`
    }
  } else if (recordWithoutBilling) {
    const readingDifference = meterReading - lastReading
    costString = `${readingDifference.toLocaleString()} kWh net usage`
  } else {
    const readingDifference = meterReading - lastReading
    const subtotalCents = readingDifference * product.pricePerUnit
    const taxes = useNewTaxExperience
      ? product.taxes
      : product.taxRate !== null
      ? [{ rate: product.taxRate }]
      : []
    const taxCents = calculateItemizedTaxTotal(subtotalCents, taxes)
    const totalCents = subtotalCents + taxCents
    costString = `${formatCurrencyFromMinorUnits({
      amount: totalCents,
      currency: presentmentCurrency,
    })} for ${readingDifference.toLocaleString()} kWh`
  }
  return (
    <div className="mb-2.5 text-lg font-semibold text-gray-600">
      {costString}
    </div>
  )
}

MeteredElectricCostLabel.propTypes = {
  lastReading: PropTypes.number,
  product: PropTypes.shape({
    pricePerUnit: PropTypes.number.isRequired,
    taxRate: PropTypes.number,
    taxes: PropTypes.arrayOf(
      PropTypes.shape({
        rate: PropTypes.number.isRequired,
      })
    ),
  }),
  meterReading: PropTypes.string,
  billingOption: PropTypes.string,
  useNewTaxExperience: PropTypes.bool.isRequired,
}

export default MeteredElectricCostLabel
